import {FontInformation, FontsPHPResponseClass, IFontStorageWrapper} from "@k/js/fontHandler";
import axios from "axios";

import {resourcemanagerVue} from "@km/js/resourceManagerVue";

function createFontlistForExternals(fonts:FontInformation[]): { font, fontID, outlineLineJoin }[] {
    return fonts.map((row: FontInformation) => {
        return {font: row.Font, fontID: row.FontID, outlineLineJoin: row.outlineLineJoin};
    });
}

export default {
    namespaced:true,
    state: () => ({
        fonts: [] as FontInformation[],
        fontsLoaded : false
    }),
    getters: {
        fontsLoaded:state=>state.fontsLoaded,
        getFontInfoFromFontname:state=>fontname=>{
            const fontInfo :FontInformation = state.fonts.find(f => f.Font === fontname);
            return fontInfo;
        },
        getFlattenedFontGroups: state=>state.fonts,
        getFontGroups:state=>state.fontGroups,
        getFontLoadedStatus:state=>font=>{
            const fontEntry = state.fonts.find(f=>f.Font === font);
            if(fontEntry === undefined) {
                return false;
            }
            return fontEntry.loaded;
        },
        getFirstAvailablFont:state=>state.fonts[0]||null

    },
    mutations: {
        RESET_FONTS:state=>{
            state.fonts = [] as FontInformation[];
            state.fontsLoaded = false;
        },
        SET_FONTGROUPS:(state, data:FontsPHPResponseClass) => {
            state.fonts = data.fontGroups.standardFonts.concat(data.fontGroups.legacyFonts).concat(data.fontGroups.userSpecificFonts).concat(data.fontGroups.kkSpecificFonts);
            state.fontsLoaded = true;
        },
        FONT_FACE_LOADED:(state, {fontName, loadingStatus})=>{
            const fontInfoInState = state.fonts.find(f=>f.Font === fontName);
            if(fontInfoInState === undefined) {
                return;
            }
            fontInfoInState.loaded = loadingStatus;
        }
    },
    actions: {
        createNewFontList:(context, language)=>{
            context.commit("RESET_FONTS");
            axios({
                url:"/konfigurator_php/designmodul/fonts.php?language="+language,
                method:"get"
            }).then((response)=>{
                context.commit("SET_FONTGROUPS", response.data);
                resourcemanagerVue.registerResource({
                    resourceName: "fonts",
                    invalidatedWhen: "fontsreload",
                    data: createFontlistForExternals(context.getters.getFlattenedFontGroups),
                    startingStati: ["loaded"]
                })
            })
        }
    },
}

export class FontStorageWrapper implements IFontStorageWrapper{
    private store;

    public constructor(store) {
        this.store = store;
    }

    reset() {
        resourcemanagerVue.executeInvalidation("fontsreload");
        this.store.commit("FontStore/RESET_FONTS");
    }

    getFontLoadedStatus(fontID) {
        return this.store.getters["FontStore/getFontLoadedStatus"](fontID)
    }

    getFontInfoFromFontName(fontname): FontInformation|undefined {
        return this.store.getters["FontStore/getFontInfoFromFontname"](fontname);
    }

    createFontList(language) {
        this.store.dispatch("FontStore/createNewFontList", language);
    }

    getFlattenedFontList() {
        return this.store.getters["FontStore/getFlattenedFontGroups"]
    }

    fontsAreLoaded(): boolean {
        return this.store.getters["FontStore/fontsLoaded"]
    }

    getFirstAvailablFontName(): string | null {
        return this.store.getters["FontStore/getFirstAvailablFont"].Font
    }

    setFontInfoLoadingStatus(fontName:string, loadingStatus:boolean) {
        this.store.commit("FontStore/FONT_FACE_LOADED", {fontName, loadingStatus})
    }
}
